import { gql } from '@apollo/client';

export const GET_COMMUNICATION_PREFERENCES = gql`
  query GetCommunicationPreferences($profileId: String!) {
    vm {
      profile(profileId: $profileId) {
        profileId
        userId
        userPreference {
          rosterView
          databaseTaskFields
          calendarInvitesEnabled
        }
      }
    }
  }
`;